// extracted by mini-css-extract-plugin
export default {"header":"header_header__SJBWl","title":"header_title__Im8p4","collapse":"header_collapse__dyYcc","header--open":"header_header--open__wQiZv"};